import React from 'react'
import HeaderDesktop from './Header.desktop'
import HeaderMobile from './Header.mobile'
import { OrderEventsConsumer } from '../../firebase/OrderEvents'

const Header = (props) => (
  <OrderEventsConsumer>
    {({ ts }) => (
      <>
        <HeaderDesktop {...props} ts={ts} />
        <HeaderMobile {...props} ts={ts} />
      </>
    )}
  </OrderEventsConsumer>
)

export default Header
